module.exports = {"transport":"ws","websocket":"wss://steemd.steemit.com","websocketdev":"wss://steemd.steemitdev.com","uri":"https://steemd.steemit.com","url":"","dev_uri":"https://steemd.steemitdev.com","stage_uri":"https://steemd.steemitstage.com","address_prefix":"STM","chain_id":"0000000000000000000000000000000000000000000000000000000000000000"}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 82
// module chunks = 0 1